module.exports = __webpack_public_path__ + "img/docker.42d73f0f.svg";